import { useState } from 'react';
import {
  PortalContactsRequest,
  PortalContact,
  PortalClientAccountsRequest,
  PortalClientAccount,
} from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function usePortalContacts() {
  const [contacts, setContacts] = useState<PortalContact[]>([]);
  const [clientAccounts, setClientAccounts] = useState<PortalClientAccount[]>([]);

  async function fetchPortalContacts(params: PortalContactsRequest) {
    try {
      const res = await api.fetchPortalContacts(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setContacts(res.Contacts);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async function fetchPortalClientAccounts(params: PortalClientAccountsRequest) {
    try {
      const res = await api.fetchPortalClientAccounts(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setClientAccounts(res.ClientAccounts);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  return {
    contacts,
    fetchPortalContacts,
    clientAccounts,
    fetchPortalClientAccounts,
  };
}
